'use client';

import { type HTMLAttributes } from 'react';

import { cn } from '@/libs';

import { IconDynamic, type IconName } from '..';

type BadgeProps = HTMLAttributes<HTMLDivElement> & {
  icon?: IconName;
  text: string;

  cnText?: string | undefined;
  iconProps?: React.SVGProps<SVGSVGElement>;
};

export const Badge = ({
  text,
  icon,
  iconProps,
  cnText,
  className,
  ...props
}: BadgeProps) => {
  return (
    <div
      className={cn(
        'flex flex-row items-center justify-center gap-0.5 w-20 rounded-sm bg-error',
        className,
      )}
      {...props}
    >
      {icon && IconDynamic(icon, iconProps)}
      <span className={cn('text-foreground text-xs font-bold uppercase', cnText)}>
        {text}
      </span>
    </div>
  );
};
